// extracted by mini-css-extract-plugin
module.exports = {"contentMargin":"styles_contentMargin__2fKzA"};